import { render } from "./LeftMenuPanel.vue?vue&type=template&id=35569708&scoped=true&ts=true"
import script from "./LeftMenuPanel.vue?vue&type=script&lang=ts"
export * from "./LeftMenuPanel.vue?vue&type=script&lang=ts"

import "./LeftMenuPanel.vue?vue&type=style&index=0&id=35569708&scoped=true&lang=css"
import "./LeftMenuPanel.vue?vue&type=style&index=1&id=35569708&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35569708"]])

export default __exports__